<template>
  <div class="raman-query-container">
    <search :formModel="formModel" :formButton="formButton" :deviceModelBusiType="12"></search>

    <div class="charts-wrap">
      <v-chart class="charts" @click="handleChartClick" :options="options" :autoresize="true" />
    </div>

    <m-table
      i18n-path="ramanQuery"
      :loading="loading"
      :tableData="tableData"
      :tableColumn="tableColumn"
      :oprateMenu="oprateMenu"
      :pagiOption="pagiOption"
      v-on:search="search"
    ></m-table>
  </div>
</template>

<script>
import { getRamanTestResult } from '@/api/raman-query.js';

import Search from '@/components/mTable/search';
import MTable from '@/components/mTable/m-table';
import { awaitTo, dayTime } from '@/utils/utils';
import { formatTime } from '@/utils/date';
import { isEmpty } from '@/utils/is';
import { lineAreaStyle } from '@/echartOption/lineAreaStyle';
import { gradientColor } from '@/echartOption/common';

import { useDialog } from './components/n-dialog/index.js';

export default {
  name: 'checkList',
  props: {
    sn: String
  },
  components: { Search, MTable },
  data() {
    return {
      tableData: [],
      options: lineAreaStyle({
        color: ['#3a6ef0'],
        title: {
          left: 'center',
          text: '预测值',
          textStyle: {
            color: '#02d6e6'
          }
        },
        xAxis: {
          axisLine: {
            lineStyle: {
              color: '#02d6e6'
            }
          }
        },
        yAxis: {
          axisLine: {
            lineStyle: {
              color: '#02d6e6'
            }
          },
          min(v) {
            const a = v.min - (v.max - v.min) / 3;

            const p = 1000;

            return parseInt(a * p) / p;
          },
          max(v) {
            const a = v.max + (v.max - v.min) / 3;

            const p = 1000;

            return parseInt(a * p) / p;
          }
        },
        series: [
          {
            type: 'line',
            areaStyle: { color: gradientColor('#3a6ef0') }
          }
        ]
      }),
      loading: true,
      // 用于清除页面状态 调用 $destroy
      formModel: {
        deviceModel: '',
        sn: '',
        rangeDateVal: [dayTime().begin.getTime(), dayTime().end.getTime()]
      },
      pagiOption: {
        offset: 1,
        limit: 10,
        total: 0,
        pagiSize: [10, 15, 20, 30],
        layout: 'total, sizes, prev, pager, next, jumper'
      },
      tableColumn: [
        { label: '客户端名称', prop: 'clientName' },
        { label: '设备号', prop: 'deviceSn' },
        { label: '测试编号', prop: 'testSeq' },
        { label: '测试名称', prop: 'testName' },
        { label: '预测名', prop: 'predictName' },
        { label: '预测值', prop: 'predictValue' },
        // { label: '修正后预测值', prop: 'fixedPredictValue' },
        {
          label: '控制箱温度',
          prop: 'ctrlBoxTemp',
          temp: ({ row }) => `${row.ctrlBoxTemp}℃`
        },
        // { label: '激光功率', prop: 'laserPower' },
        { label: '激光器温度', prop: 'laserTemp', temp: ({ row }) => `${row.laserTemp}℃` },
        { label: '采集次数', prop: 'collectCount' },
        {
          label: '采样标识',
          prop: 'sampleFlag',
          temp: ({ row }) => ['非采样', '采样'][row.sampleFlag]
        },
        { label: '开始时间', prop: 'beginTime', temp: ({ row }) => formatTime(row.beginTime) },
        { label: '结束时间', prop: 'endTime', temp: ({ row }) => formatTime(row.endTime) }
      ],
      oprateMenu: {
        label: '操作',
        width: '259px',
        list: [
          {
            text: '所有光谱',
            event: (_index, data) => {
              this.openDialog(data);
            }
          }
        ]
      },
      formButton: [
        {
          text: '查询',
          code: '010801',
          event: () => {
            this.pagiOption.offset = 1;
            this.search();
          }
        }
      ]
    };
  },

  computed: {},

  methods: {
    async search() {
      this.loading = true;

      const [err, res] = await awaitTo(
        getRamanTestResult({
          deviceSn: this.formModel.sn,
          beginTimeLong: this.formModel.rangeDateVal[0],
          endTimeLong: this.formModel.rangeDateVal[1],
          offset: this.pagiOption.offset,
          limit: this.pagiOption.limit
        })
      );

      if (err || isEmpty(res?.data?.list)) {
        this.loading = false;
        this.$message.warning(this.translateTo('暂无数据'));
        return;
      }

      this.pagiOption.total = res.data.total;

      this.tableData.splice(0, Infinity, ...res.data.list);

      this.options.series[0].data.splice(
        0,
        Infinity,
        ...res.data.list.map(e => [e.beginTimeLong, e.predictValue]).sort((a, b) => a[0] - b[0])
      );

      this.loading = false;
    },
    handleChartClick(data) {
      const { dataIndex } = data;

      const row = this.tableData[dataIndex];

      this.openDialog(row);
    },
    openDialog(data) {
      useDialog({
        title: this.$t('所有光谱'),
        row: data,
        width: '80vw',
        height: '70vh',
        marginTop: '10vh'
      });
    }
  },
  mounted() {
    this.search();
  }
};
</script>

<style lang="scss">
.raman-query-container {
  box-sizing: border-box;
  position: relative;

  .charts-wrap {
    width: 100%;
    height: max-content;

    position: relative;

    border-radius: 8px;
    background: #0c1620;

    &::after {
      content: ' ';

      display: block;

      width: 100%;
      padding: 12% 0;
    }

    .charts {
      width: 100%;
      height: 100%;

      position: absolute;
      left: 0;
      top: 0;
    }
  }

  .m-table {
    background: #0c1620;
    padding: 20px;
    border-radius: 8px;
    margin-top: 20px;
  }

  .raman-search-box {
    position: absolute;
    right: 10px;
    top: 0;
  }
}
</style>
